import React from 'react';

import { Nav, Navbar } from 'react-bootstrap';
 
const Codebar = () => {
    return (
      <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
        <Navbar.Brand href="/">Quick Links</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link href="#csols">Contest Solutions</Nav.Link>
          <Nav.Link href="#kidovid19">Kidovid 19</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
}
 
export default Codebar;